import { render, staticRenderFns } from "./ListaCreditosEnMoraPorPersona.vue?vue&type=template&id=076e161c"
import script from "./ListaCreditosEnMoraPorPersona.vue?vue&type=script&lang=js"
export * from "./ListaCreditosEnMoraPorPersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports